import { ITooltipComp } from "@ag-grid-community/core";

export class AgErrorTooltip implements ITooltipComp {
    eGui!: HTMLElement;
    init(params) {
      const eGui = (this.eGui = document.createElement('div'));
      eGui.classList.add('validation-tooltip');

      // const data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
      const valueToDisplay = params.value;

      eGui.innerHTML = `
      <div class="ag-val-error-tooltip-title">Error:</div>
      <div class="ag-val-error-tooltip-body">${valueToDisplay}</div>
      `;
      
      // eGui.style['background-color'] = 'yellow';

    }
  
    getGui() {
      return this.eGui;
    }
  }